import * as React from 'react';

import type { CloseableCauses } from './useCloseable';

// React context to pass the close callback.
export const PortalContext = React.createContext((_causes?: CloseableCauses) => {});

export function useCurrentPortal(): {
    close: () => void;
} {
    const close = React.useContext(PortalContext);

    return { close };
}
